import { render } from "./LawAssistantPage.vue?vue&type=template&id=32c7901f&ts=true"
import script from "./LawAssistantPage.vue?vue&type=script&lang=ts"
export * from "./LawAssistantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__